/* eslint-disable prefer-arrow-callback */
import React, { Dispatch, SetStateAction } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Grid, TextField } from '@material-ui/core';
import { UserService } from '../../../services/User/UserService';

interface ISitesAutocomplete {
  selectedSite: string;
  setSelectedSite: Dispatch<SetStateAction<string | null>>;
  disabled?: boolean;
  customSites?: Array<string>;
}

export const SitesAutocomplete: React.FC<ISitesAutocomplete> = ({ selectedSite, setSelectedSite, disabled, customSites }) => {
  const sites = UserService.useSitesFromAccess();

  const handleChangeSiteDomain = (_event: unknown, option: string | null) => {
    setSelectedSite(option);
  };

  return (
    <Grid item xs={10}>
      <Autocomplete
        id="siteDomain"
        disabled={disabled}
        options={customSites || sites}
        onChange={handleChangeSiteDomain}
        value={selectedSite}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            variant="standard"
            label="Sites"
          />
        )}
      />
    </Grid>
  );
};

SitesAutocomplete.defaultProps = {
  disabled: false,
};
